<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Delete {{field}}?</modal-header>
        </div>
        Are you sure you want to delete this user?
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes, delete"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {userMixin} from '@/mixins/userMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_user_confirm',
  mixins: [modalMixin, userMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    type: String,
    field: String,
    confirmId: String
  },
  data: () => ({}),
  mounted () {},
  computed: {},
  methods: {
    confirm () {
      this.startLoading()
      this.deleteUser(this.confirmId).then(() => {
        this.getUsers().then(() => {
          this.finishLoading()
          this.addNotification('success', `${this.field} has now been deleted.`)
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/users/modal-user-confirm.vue